import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import React from 'react';
import { useLocation } from 'react-router-dom';
import queryparse from 'tricks/string/queryparse';
import { useTranslation } from 'react-i18next';
import { getNumberOfPages, getPageFromQuery, locationWithPageNumber } from 'utils/pagination';
import { useFetchMyHistoryContent, PROFILE_ITEMS_PER_PAGE } from 'actions/content';
import Box from 'components/Box';
import Heading from 'components/Heading';
import PageSection from 'components/PageSection';
import Pagination from 'components/Pagination';
import HeadingWithFilters from 'components/HeadingWithFilters';
import ContentTypeFilter from '../ContentTypeFilter';
import StatusFilter from '../StatusFilter';
import ItemsGrid from '../ItemsGrid';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function History() {
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var type = queryParams.type,
    status = queryParams.status;
  var page = getPageFromQuery({
    query: queryParams
  });
  var _useFetchMyHistoryCon = useFetchMyHistoryContent({
      type: type,
      status: status,
      page: page
    }),
    items = _useFetchMyHistoryCon.items,
    isLoading = _useFetchMyHistoryCon.isLoading,
    isError = _useFetchMyHistoryCon.isError,
    total = _useFetchMyHistoryCon.total;
  var pageCount = getNumberOfPages({
    total: total,
    itemsPerPage: PROFILE_ITEMS_PER_PAGE
  });
  var hasFilters = type && type !== 'all' || status && status !== 'all';
  var emptyContent = hasFilters ? t('error_no_filter_results') : t('error_no_viewed_or_completed_content');
  return /*#__PURE__*/_jsxs(PageSection, {
    children: [/*#__PURE__*/_jsxs(HeadingWithFilters, {
      heading: /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: t('history_title')
      }),
      children: [/*#__PURE__*/_jsx(ContentTypeFilter, {}), /*#__PURE__*/_jsx(StatusFilter, {})]
    }), /*#__PURE__*/_jsx(ItemsGrid, {
      items: items,
      isError: isError,
      isLoading: isLoading,
      emptyContent: emptyContent,
      priorityPillType: "latestInteraction"
    }), pageCount > 1 && /*#__PURE__*/_jsx(Box, {
      mt: "m",
      children: /*#__PURE__*/_jsx(Pagination, {
        pageCount: pageCount,
        currentPage: page,
        getPageLink: function getPageLink(pageNumber) {
          return locationWithPageNumber({
            location: location,
            page: pageNumber
          });
        }
      })
    })]
  });
}
export default History;